
<template>
  <section class="ph-steps">
    <div class="ph-overlay"></div>

    <div class="container ph-inner">
      <h2><span>3 étapes</span> et vous êtes sur la route !</h2>

      <div class="ph-grid">
        <div
          v-for="step in steps"
          :key="step.number"
          class="ph-step"
        >
          <span class="ph-number">{{ step.number }}</span>

          <div class="ph-icon">
            <svg
              v-if="step.number === '1'"
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle cx="12" cy="12" r="9"/>
              <circle cx="12" cy="12" r="4"/>
              <path d="M12 3v5M12 16v5M3 12h5M16 12h5"/>
            </svg>

            <svg
              v-else-if="step.number === '2'"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path d="m4 20 10-10M14 5l5 5"/>
              <path d="M15 3a5 5 0 0 0-5 6l5 5a5 5 0 0 0 6-5l-3 2-4-4z"/>
            </svg>

            <svg v-else viewBox="0 0 24 24" fill="none">
              <path d="M5 15 3 13l2-7h14l2 7-2 2"/>
              <path d="M3 13h18v5H3z"/>
              <circle cx="7" cy="18" r="1"/>
              <circle cx="17" cy="18" r="1"/>
            </svg>
          </div>

          <div class="ph-copy">
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks",

  data() {
    return {
      steps: [
        {
          number: "1",
          title: "Choisissez vos pneus",
          description:
            "Sélectionnez vos dimensions et comparez les modèles.",
        },
        {
          number: "2",
          title: "Choisissez votre livraison",
          description:
            "Retenez l'option proposée qui vous convient.",
        },
        {
          number: "3",
          title: "Prenez la route sereinement",
          description:
            "Faites monter vos pneus et profitez de votre trajet.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.ph-steps {
  position: relative;
  isolation: isolate;
  padding: 30px 0 39px;
  color: #fff;
  background-color: #141b21;
  background-image: url("/assets/images/produpneu-hero.jpg");
  background-size: cover;
  background-position: center 65%;
  font-family: "Poppins", sans-serif;
}

.ph-overlay {
  position: absolute;
  z-index: -1;
  inset: 0;
  background: rgba(12, 19, 25, .85);
}

.ph-inner {
  position: relative;
  z-index: 1;
}

.ph-inner > h2 {
  margin: 0 0 27px;
  text-align: center;
  color: #fff;
  font-size: clamp(20px, 2vw, 28px);
  font-weight: 900;
}

.ph-inner > h2 span {
  color: #ff7900;
}

.ph-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.ph-step {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.ph-number {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  color: #fff;
  background: #ff7900;
  font-size: 17px;
  font-weight: 900;
}

.ph-icon {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  background: #fff;
  color: #222a31;
  border-radius: 50%;
  box-shadow: 0 8px 25px rgba(0,0,0,.17);
}

.ph-icon svg {
  width: 34px;
  height: 34px;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.ph-copy h3 {
  margin: 0 0 5px;
  color: #fff;
  font-size: 13px;
  font-weight: 850;
  line-height: 1.45;
}

.ph-copy p {
  margin: 0;
  color: #d0d5da;
  font-size: 11px;
  line-height: 1.7;
}

@media (max-width: 991px) {
  .ph-grid {
    grid-template-columns: 1fr;
    max-width: 540px;
    margin: 0 auto;
    gap: 20px;
  }
}

@media (max-width: 480px) {
  .ph-steps {
    padding: 30px 0;
  }

  .ph-step {
    gap: 10px;
  }

  .ph-icon {
    width: 50px;
    height: 50px;
  }

  .ph-icon svg {
    width: 27px;
    height: 27px;
  }

  .ph-number {
    width: 31px;
    height: 31px;
    font-size: 14px;
  }
}
</style>
